module.exports = __webpack_public_path__ + "static/img/6.d7543f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/6.png
// module id = uKM8
// module chunks = 0